import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Evento } from '../../models/evento.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@/app/shared/shared.module';
import { DialogComponent } from '@/app/shared/dialog/dialog.component';
import { EventoService } from '../../services/evento.service';

@Component({
  selector: 'c-event-view',
  templateUrl: './event-view.component.html',
  styleUrl: './event-view.component.css',
  imports: [CommonModule, FormsModule, SharedModule],
  standalone: true,
})
export class EventViewComponent {
  @Input() event!: Evento | undefined;
  @Input() date!: Date;

  show = false;

  alertOptions: { name: string; value: number }[] = [
    { name: 'Ninguna', value: 0 },
    { name: '30 minutos antes', value: 30 },
    { name: '1 hora antes', value: 60 },
    { name: '2 horas antes', value: 120 },
    { name: '1 día antes', value: 1440 },
    { name: '2 día antes', value: 2880 },
    { name: '1 semana antes', value: 10080 },
  ];

  repeatOptions: { name: string; value: number }[] = [
    { name: 'No repetir', value: 0 },
    { name: 'Diariamente', value: 1 },
    { name: 'Semanalmente', value: 7 },
    { name: 'Cada 2 semanas', value: 14 },
    { name: 'Mensualmente', value: 30 },
    { name: 'Anualmente', value: 365 },
  ];

  getAlert(value: number) {
    return (
      this.alertOptions.find((i) => i.value == value)?.name ??
      'Nada que mostrar'
    );
  }

  getRepeat(value: number) {
    return (
      this.repeatOptions.find((i) => i.value == value)?.name ??
      'Nada que mostrar'
    );
  }

  private readonly service = inject(EventoService);
  @Output() removeItem = new EventEmitter<number>();

  @ViewChild('dialog') dialog!: DialogComponent;
  remove(id: number) {
    this.dialog.confirm(
      '¿Está seguro / a de eliminar el siguiente evento?',
      'Confirmación de carga',
      () => {
        this.onRemove(id);
      },
    );
  }
  private onRemove(id: number) {
    this.service.remove(id).subscribe({
      next: (data) => {
        this.dialog.stop(
          'El evento se eliminó correctamente',
          'Confirmación de carga',
          () => {
            this.removeItem.emit(id);
            this.event = undefined;
          },
        );
      },
      error: (err) => {
        this.dialog.stop(
          'Ocurrió un error durante la carga',
          'Error de carga',
          () => {},
          true,
        );
      },
    });
  }
}
